module.exports = __webpack_public_path__ + "static/media/dashboardIt.66d1e323.svg";